import React from "react";
import { useAuth } from "../../../contexts/auth";
import { IMenu } from "../../../interfaces/IMenu";
import MenuLayout from "../../components/MenuLayout/MenuLayout";
import './IFrame.css';

interface Props {
    menu: IMenu;
}

const IFrame = ({ menu }: Props) => {

    return (
        <MenuLayout currentPage={menu.nombre}>
            <div className="iframe_container">
                <iframe src={menu?.linkIFrame!} allow="fullscreen" width={"100%"}></iframe>
            </div>
        </MenuLayout>
    );
}

export default IFrame;